import { Box, Grid, Modal, Typography } from '@mui/material';
import { useCallback, useEffect, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { default as CustomButton } from '../../components/atoms/button';
import InputTextField from '../../components/atoms/input-field/inputTextField';
import { saveModalButtonGrid, saveModalStyle } from '../../styles';
import { keyMapper, validateRequiredInputField } from '../../utils';

//My Saved View Modal
const MySavedViewModal = props => {
  const {
    openSaveModal,
    onCloseModalClick,
    errorMessage,
    setFilterName,
    getAllFilters,
    setErrorMessage,
    onSaveModalClick,
  } = props;
  const { t } = useTranslation();

  const allFiltersName = useMemo(() => {
    return getAllFilters.length > 0
      ? keyMapper(getAllFilters, 'FilterName')
      : [];
  }, [getAllFilters]);

  //debounce timeout
  const validationTimeoutRef = useRef(null);

  const handleFilterName = useCallback(
    event => {
      const newFilterName = event.target.value;
      setFilterName(newFilterName);

      if (validationTimeoutRef.current) {
        clearTimeout(validationTimeoutRef.current);
      }

      validationTimeoutRef.current = setTimeout(() => {
        const trimmedName = newFilterName.trim();
        const ValidationMessage = validateRequiredInputField(
          trimmedName,
          t,
          allFiltersName
        );
        setErrorMessage(ValidationMessage);
      }, 300);
    },
    [setFilterName, setErrorMessage, t, allFiltersName]
  );

  useEffect(() => {
    return () => {
      if (validationTimeoutRef.current) {
        clearTimeout(validationTimeoutRef.current);
      }
    };
  }, []);

  return (
    <Grid>
      {openSaveModal && (
        <Modal
          open={openSaveModal}
          onClose={onCloseModalClick} // Callback fired when the component requests to be closed. Reason Can be: "escapeKeyDown", "backdropClick"
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box style={saveModalStyle}>
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              color="#0d6efd"
            >
              {t('Saved_View_Name')}
            </Typography>
            <Grid width={400}>
              <Grid
                sx={{
                  margin: '20px 10px 0px 30px',
                  color: 'red',
                }}
              >
                {errorMessage}
              </Grid>
              <InputTextField
                name={'saveFilterName'}
                placeholder={t('Enter_Saved_View_Name')}
                style={{
                  padding: '10px',
                  margin: '10px 10px 30px 30px',
                  borderRadius: '5px',
                }}
                onChange={event => handleFilterName(event)}
              />
            </Grid>
            <Grid style={saveModalButtonGrid}>
              <CustomButton title={t('Cancel')} onClick={onCloseModalClick} />
              <CustomButton
                title={t('Save')}
                onClick={onSaveModalClick}
                disabled={errorMessage !== ''}
              />
            </Grid>
          </Box>
        </Modal>
      )}
    </Grid>
  );
};

export default MySavedViewModal;
